import ChessRestClient from '@/Api/ChessRestClient';
import {useQuery} from '@tanstack/react-query';

export default function useGetInboxApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const query = useQuery({
    queryKey: ['inbox'], // unique cache key for this query
    queryFn: async () => {
      //   const response = await ChessRestClient.get('/inbox/get_inbox');
      const response = await ChessRestClient.get('/inbox/get_inbox');
      return response.data;
    },
    onSuccess: data => {
      handleOnSuccess?.(data);
    },
    onError: error => {
      handleOnError?.(error);
    },
    structuralSharing: false, 
  });

  return {
    ...query, // gives access to data, isLoading, isError, refetch, etc.
  };
}
